
import '../PaymentLoader/Loader.scss';
import TestLoader from "../../../assets/images/vactor/test-loader.gif";
import AiBot from "../../../assets/images/vactor/chat-bot-icon.svg";

const McqLoader = () => {
  return (
    <div className="loader-wrapper">
      {/* <img src={TestLoader} alt="TestLoader" style={{width:"120px"}}/> */}
      <div className="square bounce2">
              <img src={AiBot} alt="" />
            </div>
      <p>Generating test. Please wait!</p>
    </div>
  );
};

export default McqLoader;
